import React, { ReactNode, useEffect, useState } from "react";
import { Button } from "@wearewqa/wqa-design-system";
import { DownloadItemType } from "../../types";
import { getBetasByAppId } from "../../resources/apps";
import { ItemRow } from "../../components/ItemRow";
import { useAuth } from "../../hooks/auth.provider";
import { CreateBetaModal } from "../../modals/CreateBetaModal";
import { sort } from "../../utilities";
import { AreYouSureModal } from "../../modals/AreYouSureModel";
import { deleteBetas } from "../../resources/betas";

type AppPageBetaListType = {
  appId: string | undefined;
  storeId: string | number;
};

export const AppPageListBeta = ({ appId, storeId }: AppPageBetaListType) => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [betaData, setBetaData] = useState<DownloadItemType[] | null>(null);
  const { currentUser, isAuthenticated } = useAuth();

  // confirmation Model - TODO: find a better way.
  const [confirmationModel, setConfirmationModel] = useState<ReactNode | null>(
    null
  );

  async function handleDeleteBeta(versionId: string) {
    try {
      if (!currentUser) {
        return;
      }
      const idToken = await currentUser.getIdToken();
      await deleteBetas(versionId, idToken);
      window.location.reload();
    } catch (error) {
      console.error("AppPageListBeta - handleDeleteBeta: ", error);
    }
  }

  useEffect(() => {
    async function getData() {
      try {
        if (typeof appId !== "string") {
          console.error('Error: URL parameter "appId" is not a string.');
          return;
        }

        const betas = await getBetasByAppId(appId, { store_id: storeId });
        const sortedArray = sort<DownloadItemType>(
          betas.body,
          "created_at",
          "decending"
        );

        setBetaData(sortedArray);
      } catch (error) {
        console.error("getAppData: ", error);
      }
    }

    void getData();
  }, [appId, storeId]);

  return (
    <div className="app-page__app-list">
      <>
        <div>
          {betaData !== null && betaData.length ? (
            <h2 className="app-page__sub-header">Beta Versions</h2>
          ) : (
            <></>
          )}
          {isAuthenticated && appId && (
            <>
              <Button
                label="Upload a new Beta"
                onClick={() => setShowForm(true)}
              />
              <CreateBetaModal
                isOpen={showForm}
                onClose={() => setShowForm(false)}
                appId={appId}
              />
            </>
          )}
        </div>

        {betaData !== null && betaData.length ? (
          <div className="app-page__list">
            {betaData.map((current, index) => (
              <ItemRow
                data={current}
                key={index}
                onDelete={() => {
                  setConfirmationModel(
                    <AreYouSureModal
                      isOpen={true}
                      message={`You are about to DELETE beta: "${current.display_name || current.version_number}".`}
                      onAccept={() => void handleDeleteBeta(String(current.id))}
                      onClose={() => setConfirmationModel(null)}
                    />
                  );
                }}
              />
            ))}
          </div>
        ) : (
          <></>
        )}
        {confirmationModel}
      </>
    </div>
  );
};
